import { useNavigate } from 'react-router-dom'

/**
 * Гаджет: календарь обслуживания.
 *
 * Те же сроки, что в напоминаниях, но разложенные по времени: список
 * отвечает «что горит», календарь — «когда планировать». Пустые
 * корзины не рисуем, иначе половина гаджета занята нулями.
 */
const TONE = { overdue: 'danger', week: 'warning', month: 'info', later: 'neutral' }

export function ServiceCalendarWidget({ data }) {
  const navigate = useNavigate()

  if (!data.total) {
    return <p className="widget-empty">Ближайших работ не запланировано</p>
  }

  return (
    <div className="calendar">
      {data.buckets
        .filter((b) => b.count > 0)
        .map((b) => (
          <section key={b.key} className="calendar__bucket">
            <header className={`calendar__head calendar__head--${TONE[b.key]}`}>
              <span className="calendar__label">{b.label}</span>
              <span className="calendar__count">{b.count}</span>
            </header>

            <ul className="widget-list">
              {b.items.map((it, i) => (
                <li key={`${it.car_id}-${it.label}-${i}`}>
                  <button
                    type="button"
                    className="calendar__row"
                    onClick={() => navigate(`/admin/cars/${it.car_id}`)}
                  >
                    <span className="calendar__work">{it.label}</span>
                    <span className="calendar__car">
                      {it.car}
                      {it.plate ? <span className="plate">{it.plate}</span> : null}
                    </span>
                    <span className="calendar__when">
                      {it.days_left < 0
                        ? `${Math.abs(it.days_left)} дн. назад`
                        : it.days_left === 0
                          ? 'сегодня'
                          : `через ${it.days_left} дн.`}
                    </span>
                  </button>
                </li>
              ))}
              {b.count > b.items.length && (
                <li className="calendar__more">и ещё {b.count - b.items.length}</li>
              )}
            </ul>
          </section>
        ))}
    </div>
  )
}
